import { classNames } from "primereact/utils";
import { Icon, IconType } from "../../../common/icons/Icon";
import { RenderWhen } from "../../../common/infrastructure/components/RenderWhen";
import { getRelativeAccessLabel } from "../../../common/utilities/plannyAccessUtility";
import { IAiConversationListItem, aiAssistantTexts } from "../models/aiAssistantModels";
import styles from "./AiConversationList.module.scss";

interface IAiConversationListProps {
  conversations: IAiConversationListItem[];
  selectedId: string | null;
  isLoading: boolean;
  isDeleting: boolean;
  onSelect: (item: IAiConversationListItem) => void;
  onDelete: (item: IAiConversationListItem) => void;
}

export const AiConversationList = ({
  conversations,
  selectedId,
  isLoading,
  isDeleting,
  onSelect,
  onDelete,
}: IAiConversationListProps) => {
  if (isLoading) {
    return (
      <div className={styles.root} aria-busy="true">
        {[1, 2, 3].map((index) => (
          <div key={index} className={styles.skeleton} />
        ))}
      </div>
    );
  }

  if (conversations.length === 0) {
    return <p className={styles.empty}>{aiAssistantTexts.noConversations}</p>;
  }

  return (
    <ul className={styles.root} aria-label={aiAssistantTexts.conversations}>
      {conversations.map((item) => {
        const title = item.title || aiAssistantTexts.untitledConversation;
        const isSelected = item.id === selectedId;
        return (
          <li key={item.id} className={classNames(styles.item, { [styles.item_selected]: isSelected })}>
            <button
              type="button"
              className={styles.item_main}
              onClick={() => onSelect(item)}
              aria-current={isSelected ? "true" : undefined}
            >
              <span className={styles.item_title}>{title}</span>
              <RenderWhen condition={!!item.lastMessageAt}>
                <span className={styles.item_date}>{item.lastMessageAt ? getRelativeAccessLabel(item.lastMessageAt) : ""}</span>
              </RenderWhen>
            </button>
            <button
              type="button"
              className={styles.item_delete}
              onClick={() => onDelete(item)}
              disabled={isDeleting}
              aria-label={`${aiAssistantTexts.deleteConversationLabel} „${title}“`}
              title={aiAssistantTexts.deleteConversationLabel}
            >
              <Icon type={IconType.DeleteIcon} width="15px" height="15px" color="currentColor" />
            </button>
          </li>
        );
      })}
    </ul>
  );
};
